import ActivateUserPage from '../components/ActivateUserPage'
import PermissionDenied from '../../../../Unauthorized/components/PermissionDenied'
import { actions } from '../modules/ActivateUser'
import { connect } from 'react-redux'

const mapStateToProps = state => state.activateUser

const mapDispatchToProps = actions

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => {
  if (props.userToken) {
    return ActivateUserPage(props)
  } else {
    return PermissionDenied(props)
  }
})
